/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LANGUAGE = "DANISH" | "ENGLISH_EU" | "ENGLISH_UK" | "ENGLISH_US" | "FRENCH" | "POLISH" | "SPANISH" | "%future added value";
export type UpdateViewerInput = {
    email?: string | null | undefined;
    jobTitle?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    phone?: string | null | undefined;
    initials?: string | null | undefined;
    userType?: string | null | undefined;
    roleId?: string | null | undefined;
    profileId?: string | null | undefined;
    departmentId?: string | null | undefined;
    holidayCalendarId?: string | null | undefined;
    language?: LANGUAGE | null | undefined;
    oldPassword?: string | null | undefined;
    newPassword?: string | null | undefined;
    labels?: Array<string | null> | null | undefined;
    profilePictureId?: string | null | undefined;
    notificationFrequency?: number | null | undefined;
    notifyOnProjectStatusChange?: boolean | null | undefined;
    notifyOnPersonJoin?: boolean | null | undefined;
    notifyOnAssignedProject?: boolean | null | undefined;
    notifyOnProjectDeadline?: boolean | null | undefined;
    notifyOnAssignedTask?: boolean | null | undefined;
    notifyOnAssignedTaskUpdate?: boolean | null | undefined;
    notifyOnTaskDeadline?: boolean | null | undefined;
    notifyOnMention?: boolean | null | undefined;
    notifyOnInvoiceDueDate?: boolean | null | undefined;
    notifyOnInvoiceOverdue?: boolean | null | undefined;
    notifyOnInvoiceDaysOverdue?: boolean | null | undefined;
    notifyOnInvoiceCreatedOrDeleted?: boolean | null | undefined;
    notifyOnInvoiceStatusChange?: boolean | null | undefined;
    notifyOnInvoiceDateReached?: boolean | null | undefined;
    notifyOnInvoicePayment?: boolean | null | undefined;
    notifyOnInvoiceDateChanged?: boolean | null | undefined;
    notifyOnInvoiceDueDateChanged?: boolean | null | undefined;
    notifyOnTaskDescriptionChange?: boolean | null | undefined;
    notifyOnTaskTitleChange?: boolean | null | undefined;
    notifyOnTaskEstimateChange?: boolean | null | undefined;
    notifyOnTaskStartDateChange?: boolean | null | undefined;
    notifyOnTaskEndDateChange?: boolean | null | undefined;
    notifyOnTaskSprintChange?: boolean | null | undefined;
    notifyOnTaskPhaseChange?: boolean | null | undefined;
    notifyOnTaskStatusColumnChange?: boolean | null | undefined;
    notifyOnTaskProjectChange?: boolean | null | undefined;
    notifyOnTaskSubtaskChange?: boolean | null | undefined;
    notifyOnTaskSubtaskEstimateChange?: boolean | null | undefined;
    notifyOnTaskCommentChange?: boolean | null | undefined;
    notifyOnTaskFileChange?: boolean | null | undefined;
    notifyOnTaskBugChange?: boolean | null | undefined;
    notifyOnTaskBlockedChange?: boolean | null | undefined;
    notifyOnTaskRepeatingChange?: boolean | null | undefined;
    notifyOnTimeOffManager?: boolean | null | undefined;
    notifyOnTimeOffOwner?: boolean | null | undefined;
    projectDeadlineNotificationPeriod?: number | null | undefined;
    taskDeadlineNotificationPeriod?: number | null | undefined;
    invoiceNotificationDaysOverdue?: number | null | undefined;
    disableNotifications?: boolean | null | undefined;
    notifyInAppOnPersonJoin?: boolean | null | undefined;
    notifyInAppOnProjectStatusChange?: boolean | null | undefined;
    notifyInAppOnAssignedProject?: boolean | null | undefined;
    notifyInAppOnProjectDeadline?: boolean | null | undefined;
    notifyInAppOnAssignedTask?: boolean | null | undefined;
    notifyInAppOnAssignedTaskUpdate?: boolean | null | undefined;
    notifyInAppOnTaskDeadline?: boolean | null | undefined;
    notifyInAppOnMention?: boolean | null | undefined;
    notifyInAppOnInvoiceDueDate?: boolean | null | undefined;
    notifyInAppOnInvoiceOverdue?: boolean | null | undefined;
    notifyInAppOnInvoiceDaysOverdue?: boolean | null | undefined;
    notifyInAppOnInvoiceCreatedOrDeleted?: boolean | null | undefined;
    notifyInAppOnInvoiceStatusChange?: boolean | null | undefined;
    notifyInAppOnInvoiceDateReached?: boolean | null | undefined;
    notifyInAppOnInvoicePayment?: boolean | null | undefined;
    notifyInAppOnInvoiceDateChanged?: boolean | null | undefined;
    notifyInAppOnInvoiceDueDateChanged?: boolean | null | undefined;
    notifyInAppOnTaskDescriptionChange?: boolean | null | undefined;
    notifyInAppOnTaskTitleChange?: boolean | null | undefined;
    notifyInAppOnTaskEstimateChange?: boolean | null | undefined;
    notifyInAppOnTaskStartDateChange?: boolean | null | undefined;
    notifyInAppOnTaskEndDateChange?: boolean | null | undefined;
    notifyInAppOnTaskSprintChange?: boolean | null | undefined;
    notifyInAppOnTaskPhaseChange?: boolean | null | undefined;
    notifyInAppOnTaskStatusColumnChange?: boolean | null | undefined;
    notifyInAppOnTaskProjectChange?: boolean | null | undefined;
    notifyInAppOnTaskSubtaskChange?: boolean | null | undefined;
    notifyInAppOnTaskSubtaskEstimateChange?: boolean | null | undefined;
    notifyInAppOnTaskCommentChange?: boolean | null | undefined;
    notifyInAppOnTaskFileChange?: boolean | null | undefined;
    notifyInAppOnTaskBugChange?: boolean | null | undefined;
    notifyInAppOnTaskBlockedChange?: boolean | null | undefined;
    notifyInAppOnTaskRepeatingChange?: boolean | null | undefined;
    notifyInAppOnTimeOffManager?: boolean | null | undefined;
    notifyInAppOnTimeOffOwner?: boolean | null | undefined;
    lastSeenInAppNotification?: number | null | undefined;
    disableInAppNotifications?: boolean | null | undefined;
    disableCelebrationAnimations?: boolean | null | undefined;
    projectDeadlineInAppNotificationPeriod?: number | null | undefined;
    taskDeadlineInAppNotificationPeriod?: number | null | undefined;
    sendNewsletter?: boolean | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    startDate?: string | null | undefined;
    endDate?: string | null | undefined;
    timerStartDate?: string | null | undefined;
    timerEndDate?: string | null | undefined;
    timerTaskId?: string | null | undefined;
    cost?: number | null | undefined;
    flowSampleStep?: string | null | undefined;
    timeLogPersonId?: string | null | undefined;
    githubPersonId?: string | null | undefined;
    gitlabPersonId?: string | null | undefined;
    gitlabServerPersonId?: string | null | undefined;
    jiraCloudId?: string | null | undefined;
    jiraServerId?: string | null | undefined;
    unit4PersonId?: string | null | undefined;
    sageIntacctId?: string | null | undefined;
    sageIntacctName?: string | null | undefined;
    sageIntacctEmail?: string | null | undefined;
    sageIntacctLocationId?: string | null | undefined;
    adoUserId?: string | null | undefined;
    onboardingInitialStep?: string | null | undefined;
    onboardingProjectPhasesStep?: string | null | undefined;
    onboardingProjectBudgetStep?: string | null | undefined;
    onboardingProjectBoardStep?: string | null | undefined;
    onboardingProjectOverviewStep?: string | null | undefined;
    onboardingTaskModalStep?: string | null | undefined;
    onboardingOverviewTimeStep?: string | null | undefined;
    setToRunningNotificationLastDismissalDate?: string | null | undefined;
    useNewUIWorkflow?: boolean | null | undefined;
    savedFiltersJson?: string | null | undefined;
    adminPassword?: string | null | undefined;
    calendarViewPrivateEvents?: boolean | null | undefined;
    hiBobId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updatePasswordMutationVariables = {
    input: UpdateViewerInput;
};
export type updatePasswordMutationResponse = {
    readonly updateViewer: {
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type updatePasswordMutation = {
    readonly response: updatePasswordMutationResponse;
    readonly variables: updatePasswordMutationVariables;
};



/*
mutation updatePasswordMutation(
  $input: UpdateViewerInput!
) {
  updateViewer(input: $input) {
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateViewerInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateViewerPayload",
    "kind": "LinkedField",
    "name": "updateViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updatePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation updatePasswordMutation(\n  $input: UpdateViewerInput!\n) {\n  updateViewer(input: $input) {\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bac4a7651074e6e41a60059cdf1c884c';
export default node;
